import React from 'react';

const VARIANTS = {
  default: {
    avatar: 'bg-[#FF5E4C]',
    ring: 'ring-[#EE5D4D]',
    pill: 'bg-[#FFE2DF] pl-[16px]',
    text: 'text-[#8F2115]',
  },
  /** Muted pill for sticky-note / dark backgrounds */
  note: {
    avatar: 'bg-[#FF5E4C]',
    ring: 'ring-white/90',
    pill: 'bg-white/25 pl-[14px] backdrop-blur-[2px]',
    text: 'text-[#5c5c5c]',
  },
};

const SIZES = {
  /** 32px circles — search cards */
  sm: {
    circle: 'h-8 w-8',
    overlap: '-ml-[11px]',
    pillPad: 'pl-1.5 pr-2.5 py-[5px]',
    pillPull: '-ml-2',
    text: 'text-[13px]',
  },
  /** 34px circles — property / event headers */
  md: {
    circle: 'h-[34px] w-[34px]',
    overlap: '-ml-[6px]',
    pillPad: 'pl-2 pr-3 py-[5px]',
    pillPull: '-ml-2.5',
    text: 'text-[14px]',
  },
};

/**
 * Two overlapping founder avatars + pill (brand or muted for sticky-note).
 */
export default function FoundersVerifiedBadge({ className = '', size = 'md', variant = 'default' }) {
  const s = SIZES[size] || SIZES.md;
  const v = VARIANTS[variant] || VARIANTS.default;

  return (
    <div
      className={`flex items-center ${className}`}
      role="img"
      aria-label="Founders verified"
    >
      <div className="relative flex shrink-0 items-center">
        <div
          className={`relative z-20 shrink-0 overflow-hidden rounded-full ${v.avatar} ring-2 ${v.ring} ${s.circle}`}
        >
          <img src="/assets/Chandler.png" alt="" className="h-full w-full object-cover rounded-full" />
        </div>
        <div
          className={`relative z-10 shrink-0 overflow-hidden rounded-full ${v.avatar} ring-2 ${v.ring} ${s.circle} ${s.overlap}`}
        >
          <img src="/assets/Joe.png" alt="" className="h-full w-full object-cover rounded-full" />
        </div>
      </div>
      <div
        className={`flex min-h-[26px] items-center rounded-r-full ${v.pill} ${v.text} ${s.pillPad} ${s.pillPull}`}
      >
        <span className={`font-sans font-normal leading-none tracking-tight text-inherit ${s.text}`}>
          Founders verified
        </span>
      </div>
    </div>
  );
}
